export default Object.freeze({
  baseURL: "https://cityhallwebapiwebapi20210131212332.azurewebsites.net/api/",
});
